import './cta.scss';
import { BaseComponent } from '../baseComponent';
import { ComponentEvents } from '../../models/events';

export default class extends BaseComponent {
  constructor(el: HTMLElement) {
    super(el);
    this.visibleTrigger = 20;
    this.el.addEventListener(ComponentEvents.READY, this.init.bind(this));
  }

  public init() {
    if (!this.el.dataset.spy) {
      this.revealElement();
    }
  }
}
